<template>
  <div v-if="!isApp" style="height:5rem" id="navbar">
    <div class="navbar-head-nav">
      <div class="navbar-head-nav-logo">
        <img src="../../assets/navLogo.png" class="navbar-head-nav-logo-img" />
      </div>
      <div class="navbar-head-nav-pull" @click="showOrCloseNav()">
        <img src="../../assets/navPullDown.png" class="navbar-head-nav-pull-img" />
      </div>
    </div>
    <div v-if="isShowNav" class="navbar-head-nav-down">
      <div :class="[isShowNavAll ? 'navbar-head-nav-content-all':'navbar-head-nav-content']">
        <div class="navbar-head-nav-column" @click="navToUrl()">
          <div class="navbar-head-nav-column-img">
            <img src="../../assets/navHome.png" />
          </div>
          <div class="navbar-head-nav-column-text">首页</div>
        </div>
        <div class="navbar-head-nav-column" @click="navToUrl('/invitation/')">
          <div class="navbar-head-nav-column-img">
            <img src="../../assets/navInvitation.png" />
          </div>
          <div class="navbar-head-nav-column-text">结婚请柬</div>
        </div>
        <div class="navbar-head-nav-column" @click="navToUrl('/luckyday/calendar')">
          <div class="navbar-head-nav-column-img">
            <img src="../../assets/navJiri.png" />
          </div>
          <div class="navbar-head-nav-column-text">结婚吉日</div>
        </div>
        <div class="navbar-head-nav-column" @click="navToUrl('/budget/')">
          <div class="navbar-head-nav-column-img">
            <img src="../../assets/navBudget.png" />
          </div>
          <div class="navbar-head-nav-column-text">结婚预算</div>
        </div>
        <div class="navbar-head-nav-column" @click="navToUrl('/task/')">
          <div class="navbar-head-nav-column-img">
            <img src="../../assets/navTask.png" />
          </div>
          <div class="navbar-head-nav-column-text">结婚任务</div>
        </div>
        <div class="navbar-head-nav-column" @click="navToUrl('/registry/')">
          <div class="navbar-head-nav-column-img">
            <img src="../../assets/navRegistry.png" />
          </div>
          <div class="navbar-head-nav-column-text">登记指南</div>
        </div>
        <div class="navbar-head-nav-column" @click="navToUrl('/vows/')">
          <div class="navbar-head-nav-column-img">
            <img src="../../assets/navVows.png" />
          </div>
          <div class="navbar-head-nav-column-text">婚礼致辞</div>
        </div>
        <div style="clear: both;"></div>
      </div>
      <div class="drop-down-arrow-line" v-if="!isShowNavAll">
        <div class="drop-down-arrow-black" @click="showDropDown">
          <img class="drop-down-arrow-black-img" src="../../assets/dropDown.png" />
        </div>
      </div>
      <div class="navbar-head-nav-down-bg" @click="showOrCloseNav()"></div>
    </div>
  </div>
</template>

<script>
import GLOBAL from '../jiri/Global'
export default {
  data() {
    return {
      isShowNav: false, //导航条下拉显示菜单
      isShowNavAll: false //导航菜单显示全部
    }
  },
  props: {
    isApp: {
      type: Number|Boolean,
      default: true
    }
  },
  mounted() {},
  methods: {
    /**
     * 导航条展开
     */
    showOrCloseNav() {
      var that = this
      that.isShowNav = that.isShowNav ? false : true
    },
    /**
     * 展开全部导航
     */
    showDropDown() {
      var that = this
      that.isShowNavAll = true
    },
    /**
     * 导航条跳转地址
     */
    navToUrl(url) {
      var that = this
      // console.log(url)
      if (url == null) {
        location.assign(GLOBAL.getIndexPage())
      } else {
        location.assign(url)
      }
    }
  }
}
</script>

<style>
.navbar-head-nav-placeholder {
  width: 100%;
  height: 5rem;
  position: relative;
}
.navbar-head-nav {
  width: 100%;
  height: 5rem;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 1);
  z-index: 999;
}
.navbar-head-nav-logo {
  position: absolute;
  top: 0;
  left: 0;
  width: 13rem;
  height: 2.4rem;
  margin-top: 1.3rem;
  margin-left: 2.2rem;
}
.navbar-head-nav-logo-img {
  width: 13rem;
  height: 2.4rem;
}
.navbar-head-nav-pull {
  position: absolute;
  top: 0;
  right: 0;
  width: 2.4rem;
  height: 2.4rem;
  margin-top: 1.3rem;
  margin-right: 2.2rem;
}
.navbar-head-nav-pull-img {
  width: 2.4rem;
  height: 2.4rem;
}
.navbar-head-nav-down {
  position: fixed;
  top: 5rem;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999999;
}
.navbar-head-nav-down-bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: -1;
}

.drop-down-arrow-line {
  width: 100%;
  height: 2.5rem;
  background: white;
}
.drop-down-arrow-black {
  width: 6rem;
  height: 2.5rem;
  background: rgba(247, 247, 247, 1);
  border-radius: 1rem 1rem 0rem 0rem;
  margin: 0 auto;
}
.drop-down-arrow-black-img {
  width: 1.5rem;
  height: 0.9rem;
  margin: 0.8rem 2.25rem;
}

.navbar-head-nav-content-all {
  width: 100%;
  background: white;
  padding-top: 2rem;
}
.navbar-head-nav-content {
  width: 100%;
  height: 8.9rem;
  overflow: hidden;
  background: white;
  padding-top: 2rem;
}
.navbar-head-nav-column {
  width: 4.7rem;
  height: 6.9rem;
  margin: 0 1.4rem 2rem 1.4rem;
  float: left;
}
.navbar-head-nav-column:last-of-type {
  margin: 0;
}
.navbar-head-nav-column-img {
  width: 4.5rem;
  height: 4.5rem;
  margin-left: 0.15rem;
}
.navbar-head-nav-column-img img {
  width: 4.5rem;
  height: 4.5rem;
}
.navbar-head-nav-column-text {
  width: 4.8rem;
  height: 1.65rem;
  font-size: 1.2rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 1.65rem;
  text-align: center;
  margin-top: 0.8rem;
}
</style>
